// let imgHref
// // if (window.location.href.split('/')[2] === 'localhost:8080') {
//     // imgHref = "http://10.10.0.30:30086/"
//     imgHref = "https://cdp-local-api.cdp.shmedia.tech/"
// imgHref = "http://cdp-local-api.dev.routeryuncs.com/"
// imgHref = "https://cdp-local-web.test.routeryuncs.com/"

// } else if (window.location.href.split('/')[2] === '10.10.0.187:8080') {
//     // imgHref = "http://10.10.0.30:30086/"
//     imgHref = "https://cdp-local-api.cdp.shmedia.tech/"
//     // imgHref = "http://cdp-local-api.dev.routeryuncs.com/"
// } else {
//     // imgHref = "http://10.10.0.30:30086/"
//     imgHref = "https://cdp-local-api.cdp.shmedia.tech/"
//     // imgHref = "http://cdp-local-api.dev.routeryuncs.com/"
//     // imgHref = location.protocol + '//' + window.location.href.split('/')[2] + '/'
// }

//  图片前缀与接口地址保持一致
// import { BASEURL } from '@/config/index'
// export const picPrefix = BASEURL + '/'

//写死图片前缀
export const picPrefix = 'https://jd.cdp.shmedia.tech/api/' //图片前缀